"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cassina-de-pecchi": {
    "8ca21e71": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "camporicco": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cassina-de-pecchi"
    }],
    "633ae166": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "14a5264d": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "colombirolo": [{
      "hkey": "a4c0f413",
      "slug": "centro-camporicco-zona-industriale",
      "name": "Centro-Camporicco-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cassina-de-pecchi"
    }],
    "01e525e1": [{
      "hkey": "6e15ed3d",
      "slug": "sant-agata-villa-pompea",
      "name": "Sant'Agata-Villa Pompea",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agata": [{
      "hkey": "6e15ed3d",
      "slug": "sant-agata-villa-pompea",
      "name": "Sant'Agata-Villa Pompea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;